import {
  mapperBlockCampaignsCallOut,
  mapperBlockCampaignsCards,
  mapperBlockCampaignsMedia,
  mapperBlockCampaignsMetrics,
  mapperBlockLandingLogoBar,
  mapperBlockLandingMediaAndText,
  mapperBlockLandingUspList
} from '~/data-layer/mappers'
import { mapperBlockLandscapeMediaThenContent } from '~/data-layer/blocks/block-landscape-media-then-content/mapper-block-landscape-media-then-content'
import { mapperBlockContentCenteredTextOnly } from '~/data-layer/blocks/block-content-centered-text-only/mapper-block-content-centered-text-only'
import { mapperModuleMedia, mapperModuleVideo } from '../../../core/data-layer/modules/mappers'
import { mapperBlockLogoBar, mapperBlockSimpleQuote } from '../../../core/data-layer/blocks/mappers'
import { mapperBlockQuoteGroup } from '../../../core/data-layer/blocks/block-quote-group/mapper-block-quote-group'
import type { MapperOptions } from '#layers/core/types'

export default (data: any, options: MapperOptions) => {
  const campaignsBlocksModuleMediaImageOptions = {
    resize: true,
    lazy: true,
    sizes: {
      small: { width: 272, height: 153, aspectRatio: '16/9' },
      medium: { width: 576, height: 324, aspectRatio: '16/9' },
      large: { width: 576, height: 324, aspectRatio: '16/9' }
    }
  }
  const campaignsBlocksModuleVideoImageOptions = {
    resize: true,
    lazy: true,
    sizes: {
      small: { width: 272, height: 153, aspectRatio: '16/9' },
      medium: { width: 576, height: 324, aspectRatio: '16/9' },
      large: { width: 576, height: 324, aspectRatio: '16/9' }
    }
  }

  const mapBlock = (item: any, options: MapperOptions) => {
    const mappersByContentType = {
      BlockLandingMediaAndText: (data: any) => mapperBlockLandingMediaAndText(data, options),
      BlockLandscapeMediaThenContent: (data: any) => mapperBlockLandscapeMediaThenContent(data, options),
      BlockContentCenteredTextOnly: (data: any) => mapperBlockContentCenteredTextOnly(data, options),
      BlockCampaignsMetrics: (data: any) => mapperBlockCampaignsMetrics(data),
      ModuleMedia: (data: any) => mapperModuleMedia(data, campaignsBlocksModuleMediaImageOptions),
      ModuleVideo: (data: any) => mapperModuleVideo(data, campaignsBlocksModuleVideoImageOptions),
      BlockLandingUspList: (data: any) => mapperBlockLandingUspList(data),
      BlockSimpleQuote: (data: any) => mapperBlockSimpleQuote(data, options.imageOptions),
      BlockCampaignsCards: (data: any) => mapperBlockCampaignsCards(data, options.getUrl),
      BlockCampaignsCallOut: (data: any) => mapperBlockCampaignsCallOut(data, options),
      BlockLogoBar: (data: any) => mapperBlockLogoBar(data, options),
      BlockLandingLogoBar: (data: any) => mapperBlockLandingLogoBar(data, options),
      BlockCampaignsMedia: (data: any) => mapperBlockCampaignsMedia(data, options),
      BlockQuoteGroup: (data: any) => mapperBlockQuoteGroup(data, options)
    }
    const mapper = mappersByContentType[item.contentType] || ((data) => data)
    if (!mappersByContentType[item.contentType]) {
      // eslint-disable-next-line no-console
      console.warn(`Mapper missing for content type for ${JSON.stringify(item)}`)
    }
    const mappedItem = mapper(item)
    mappedItem.contentType = item.contentType
    return mappedItem
  }

  const contentBlocks =
    data?.campaign?.contentBlocks?.items?.filter(Boolean).map((item) => mapBlock(item, options)) || []

  return contentBlocks
}
